/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkTypeDto } from '../../models/update-work-type-dto';
import { WorkType } from '../../models/work-type';

export interface WorkTypesControllerUpdate$Params {
  id: string;
      body: UpdateWorkTypeDto
}

export function workTypesControllerUpdate(http: HttpClient, rootUrl: string, params: WorkTypesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkType>> {
  const rb = new RequestBuilder(rootUrl, workTypesControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkType>;
    })
  );
}

workTypesControllerUpdate.PATH = '/work-types/admin/{id}';
